<script lang="ts">
  import { addObject } from "../../services/stores/object-drawer-store.js";
  import { Button } from "flowbite-svelte";
  import { Card } from "flowbite-svelte";
  import { FontAwesomeIcon } from "@fortawesome/svelte-fontawesome";
  import { faPlus, faRefresh } from "@fortawesome/free-solid-svg-icons";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let parentId: string | null = null;
  export let objectType: string;
  export let title: string;
  export let canAdd: boolean = false;
  const onAddObject = async () => {
    addObject(
      objectType as "user" | "customer" | "project",
      parentId ?? undefined
    );
  };
  const onRefreshObject = async () => {
    dispatch("refresh");
  };
</script>

<Card class="app-grid-header w-full">
  <div class="flex items-center justify-left">
    <h3 class="text-base font-bold mr-1">
      {title}
    </h3>
    {#if canAdd}
      <Button
        pill={true}
        outline={true}
        class="grid-header-button icon-only"
        size="sm"
        data-testid="grid-header-add-button"
        on:click={onAddObject}
      >
        <FontAwesomeIcon icon={faPlus} />
      </Button>
    {/if}
    <Button
      pill={true}
      outline={true}
      class="grid-header-button icon-only"
      size="sm"
      data-testid="grid-header-refresh-button"
      on:click={onRefreshObject}
    >
      <FontAwesomeIcon icon={faRefresh} />
    </Button>
  </div>
</Card>
